import { TemplateSize } from '@anm/api/modules/templates';

const sortMedia = (media: TemplateSize[]) => [...media].sort((a, b) => a.size.height - b.size.height);

export const getSmallMedia = (media: TemplateSize[]) => sortMedia(media)[0];

export const getSelectedIdFormat = (selectedIdFormat: string | null) => (selectedIdFormat || '')?.split('-');
